import React from 'react'
import * as T from '../../../components/Table'
import { ValidacaoDeNfItem } from './ValidacaoDeNfItem'
import { useUser } from '../../../hooks/useUser'

export const ValidacaoDeNfLista = ({ data }) => {
  const { codigo_usuario } = useUser()

  const usersNotPermitted = [89, 105, 117]

  const isUserPermitted = !usersNotPermitted.includes(codigo_usuario)

  if (!data.length) {
    return (
      <T.Tr>
        <T.Td colSpan="15" textAlign="center">
          Nenhum registro encontrado
        </T.Td>
      </T.Tr>
    )
  }

  return data.map((item) => <ValidacaoDeNfItem isUserPermitted={isUserPermitted} key={item.numero_pedido} item={item} />)
}
